export function htmlToText(htmlString: string) {
    if (!htmlString) return '';

    const tempElement = document.createElement('div') as HTMLDivElement;
    tempElement.innerHTML = htmlString;
    const pureText = tempElement.textContent;
    
    return pureText;
}